import { onMount, onDestroy } from "./_";
import { Resize } from "@/lib/subs";

export default function (element, dataset) {
  const tooltips = element.querySelectorAll(".lwt_tooltip_wrap");
  const images = element.querySelectorAll("img");

  function position() {
    if (window.innerWidth > 767) {
      tooltips.forEach((t) => t.classList.remove("is-flipped"));
      return;
    }

    tooltips.forEach((t) => {
      const rect = t.getBoundingClientRect();

      if (rect.left < window.innerWidth / 2) {
        t.classList.add("is-flipped");
      } else {
        t.classList.remove("is-flipped");
      }
    });
  }

  let loaded = 0;
  const total = images.length;

  images.forEach((img) => {
    if (img.complete) {
      loaded++;
    } else {
      img.addEventListener(
        "load",
        () => {
          loaded++;
          if (loaded >= total) position();
        },
        { once: true },
      );
    }
  });

  onMount(() => {
    position();
  });

  const unsub = Resize.add(position);
  onDestroy(() => unsub());
}
